import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { AssetType } from "../../../../../common/types/AssetType";
import { ConformingAssetsSection } from "../../../common/conforming-assets/ConformingAssetsSection";
import { isCloudAssetDeprecated, isInPreparation } from "../../CloudAssetDetails";
import { useCloudAssetDetails } from "../../common/hooks/useCloudAssetDetails";
import { ProxyAssetsSection } from "./proxy-assets/ProxyAssetsSection";

export const AssetsSection = (): JSX.Element => {
    const { data: assetDetails } = useCloudAssetDetails();

    if (!assetDetails) return <></>;

    return (
        <Grid>
            <GridRow>
                <GridColumn sm={12}>
                    <ConformingAssetsSection
                        assetType={AssetType.Cloud}
                        canBeDeprecated={!isCloudAssetDeprecated(assetDetails) && !isInPreparation(assetDetails)}
                        contentVersionIds={assetDetails?.content?.versionSummary.ids ?? []}
                    />
                    <ProxyAssetsSection />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
